import React from 'react';
import styles from './Policies.module.scss';
import { Col, Container, Row } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { contactSupportData, industrialContent, legalContent, policyGuidelineColumns, policyGuidelineData, policyStyles } from '../complianceData';

const Policies = () => {
    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.mainHeading}>Compliance Policies</h4>

            <Container fluid className={styles.headerText}>
                <p>
                    Welcome to the Compliance Policies Page. Here, you'll find all the necessary information
                    and resources to ensure your business operations align with our platform policies, industry
                    standards, and legal requirements. Staying compliant not only helps you avoid penalties but
                    also enhances your reputation and customer trust.
                </p>
            </Container>

            <h5 className={styles.sectionHeading}>Policies and Guidelines</h5>
            <Container fluid className={styles.mainTableContainer}>
                <div className={styles.dataTableContainer}>
                    <DataTable
                        title={"Following are the policies that you must follow from convenient working on the platform"}
                        columns={policyGuidelineColumns}
                        data={policyGuidelineData}
                        highlightOnHover
                        customStyles={policyStyles}
                    />
                </div>
            </Container>

            <h5 className={styles.sectionHeading}>Industrial Standards</h5>
            <Container fluid className={styles.listContainer}>
                <div className={styles.orderContent}>
                    <p>Adhering to industry standards ensures that your products meet the quality and safety expectations of customers.</p>
                    <p>Some key industry standards include:</p>
                    <ul>
                        {industrialContent.map((item, index) => (
                            <li key={index}>
                                <span>{item.heading}:</span> {item.content}
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>

            <h5 className={styles.sectionHeading}>Legal Requirements</h5>
            <Container fluid className={styles.listContainer}>
                <div className={styles.orderContent}>
                    <p>Understanding and adhering to legal requirements is crucial for your business.</p>
                    <p>Some key legal areas include:</p>
                    <ul>
                        {legalContent.map((item, index) => (
                            <li key={index}>
                                <span>{item.heading}:</span> {item.content}
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>

            <h5 className={styles.sectionHeading}>Compliance Monitoring</h5>
            <Container fluid className={styles.listContainer}>
                <div className={styles.orderContent}>
                    <p>
                        We continuously monitor compliance through automated checks and manual reviews. Non-compliance
                        can result in warnings or account suspension. If you believe a compliance action was taken in
                        error, you can appeal by contacting [Compliance Support number].
                    </p>
                </div>
            </Container>

            <h5 className={styles.sectionHeading}>Contact Support</h5>
            <Container fluid className={styles.contactSupportContainer}>
                <Row className={styles.contactSupportRow}>
                    {contactSupportData.map((contact, index) => (
                        <Col key={index} lg={6} className={styles.contactSupportColumn}>
                            <div className={styles.contactDetailContainer}>
                                <p className={styles.contactTitle}>{contact.title}:</p>
                                <div className={styles.contactDetails}>
                                    {contact.details?.map((dataItem, dataIndex) => (
                                        <Row key={dataIndex} className={styles.contactContentRow}>
                                            <Col lg={4}>{dataItem.label}:</Col>
                                            <Col className={styles.contactContentValue}>{dataItem.value}</Col>
                                        </Row>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    )
}

export default Policies;